import { render, staticRenderFns } from "./add-originality.vue?vue&type=template&id=75689c5a&scoped=true&"
import script from "./add-originality.vue?vue&type=script&lang=js&"
export * from "./add-originality.vue?vue&type=script&lang=js&"
import style0 from "./add-originality.vue?vue&type=style&index=0&id=75689c5a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75689c5a",
  null
  
)

export default component.exports